<template>
    <section class="bg-[#F5F5F5] py-20 sm:py-28">
        <div class="mx-auto max-w-7xl px-6 lg:px-8">
            <div class="mb-14 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6">
                <div>
                    <span class="text-xs font-semibold uppercase tracking-widest text-[#A07830]">Pricing</span>
                    <h2 class="mt-3 text-3xl sm:text-4xl font-extrabold text-[#17364a] tracking-tight">
                        Simple, Transparent<br />Pricing
                    </h2>
                    <p class="mt-4 text-sm text-gray-500 max-w-md">
                        Unlock your potential with flexible plans. Whether you are just starting or looking to advance your skills.
                    </p>
                </div>
                <!-- Tab toggle -->
                <div class="flex items-center bg-white border border-[#E5E5E5] p-1 w-fit">
                    <button
                        v-for="(tab, idx) in tabs"
                        :key="idx"
                        @click="activeTab = idx"
                        :class="[
                            'px-5 py-2 text-sm font-semibold transition-colors duration-200',
                            activeTab === idx
                                ? 'bg-[#17364a] text-white'
                                : 'text-gray-500 hover:text-[#17364a]'
                        ]"
                    >
                        {{ tab }}
                    </button>
                </div>
            </div>

            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                <div
                    v-for="(tier, tierIdx) in currentTiers"
                    :key="tier.id"
                    :class="[
                        'relative p-8 border flex flex-col',
                        tier.featured
                            ? 'bg-[#17364a] border-[#A07830] text-white'
                            : 'bg-white border-[#E5E5E5]'
                    ]"
                >
                    <!-- Most Popular badge -->
                    <div v-if="tier.featured" class="absolute top-0 right-0 bg-[#A07830] px-3 py-1 text-xs font-semibold text-white">
                        Most Popular
                    </div>

                    <h3 :class="['text-xs font-semibold uppercase tracking-widest mb-4', tier.featured ? 'text-[#A07830]' : 'text-[#A07830]']">
                        {{ tier.name }}
                    </h3>
                    <div class="flex items-baseline gap-1 mb-2">
                        <span :class="['text-4xl font-extrabold', tier.featured ? 'text-white' : 'text-[#17364a]']">
                            ${{ Number(tier.price) }}
                        </span>
                        <span :class="['text-sm', tier.featured ? 'text-gray-400' : 'text-gray-400']">/mo</span>
                    </div>
                    <p :class="['text-sm leading-relaxed mb-6', tier.featured ? 'text-gray-400' : 'text-gray-500']">
                        {{ tier.description }}
                    </p>

                    <ul class="space-y-2.5 mb-8 flex-1">
                        <li v-for="feature in tier.features" :key="feature" class="flex items-start gap-2">
                            <svg class="h-4 w-4 mt-0.5 shrink-0 text-[#A07830]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                            </svg>
                            <span :class="['text-xs', tier.featured ? 'text-gray-300' : 'text-gray-600']">{{ feature }}</span>
                        </li>
                    </ul>

                    <router-link
                        :to="{ name: 'courses' }"
                        :class="[
                            'block text-center text-sm font-semibold py-3 transition-colors duration-200',
                            tier.featured
                                ? 'bg-[#A07830] text-white hover:bg-[#C9A55A]'
                                : 'border border-[#17364a] text-[#17364a] hover:bg-[#17364a] hover:text-white'
                        ]"
                    >
                        Enroll now
                    </router-link>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
import { ref, computed } from 'vue';
import { getTiers } from '@/services/tierService';

const activeTab = ref(0);
const tabs = ['30 Minutes', '60 Minutes'];
const tiers = ref({});

getTiers().then((data) => {
    tiers.value = data.data;
});

const currentTiers = computed(() => {
    const group = tiers.value[activeTab.value];
    return group ? group.tiers : [];
});
</script>
